import { TabsBar } from '@/modules/common/components/tabs-bar';
import styles from './index.module.sass';
import { SpecItem } from '../spec-item';
import { Sorter } from '@/modules/common/components/sorter';
import { useStore } from 'effector-react';
import {
  $leftoversSort,
  $selectedRecipeStore,
  setLeftoversSortOrder,
  setLeftoversSortValue,
} from '@/modules/mixing/store/recipes.store';
import { useEffect, useState } from 'react';
import {
  $topRecipesForWarehouse,
  fetchTopRecipesForWarehouse,
} from '@/widgets/recipe/model';
import { ILeftoverBag } from '@/widgets/recipe/types';
import { LeftoversList } from '../leftovers-list';
import { DetalisationTooltip } from '@/modules/common/components/detalisation-tooltip';
import arrowIcon from '@@/mixing/components/recipes-detail/icons/arrow.svg';
import { RubleRegular } from '@/modules/common/components/ruble-regular';

export const LeftoversTab = ({
  selectRecipeFoo,
  tabs,
  activeTab,
  setActiveTab,
}: {
  selectRecipeFoo: (id: number) => void;
  tabs: {
    label: string;
    id: number;
    disabled?: boolean;
  }[];
  activeTab: number;
  setActiveTab: (val: number) => void;
}) => {
  const leftoversSort = useStore($leftoversSort);
  const [sortedData, setSortedData] = useState<ILeftoverBag[]>([]);
  const topRecipes = useStore($topRecipesForWarehouse);
  const activeWh = useStore($selectedRecipeStore);

  useEffect(() => {
    activeWh && fetchTopRecipesForWarehouse(Number(activeWh.id));
  }, []);

  useEffect(() => {
    const sortedDataCopy = topRecipes?.remaining_bags.items.slice();
    let compareFoo;
    const sortBy = leftoversSort.sortBy.find((item) => item.active);
    if (sortBy && sortBy.val === 'price') {
      leftoversSort.order === 'asc'
        ? (compareFoo = (a: ILeftoverBag, b: ILeftoverBag) => a.all_price - b.all_price)
        : (compareFoo = (a: ILeftoverBag, b: ILeftoverBag) =>
            b.all_price - a.all_price);
    } else if (sortBy && sortBy.val === 'order') {
      leftoversSort.order === 'asc'
        ? (compareFoo = (a: ILeftoverBag, b: ILeftoverBag) =>
            a.bag.localeCompare(b.bag, 'ru', { sensitivity: 'base' }))
        : (compareFoo = (a: ILeftoverBag, b: ILeftoverBag) =>
            b.bag.localeCompare(a.bag, 'ru', { sensitivity: 'base' }));
    }
    if (!compareFoo && topRecipes)
      return setSortedData(topRecipes?.remaining_bags.items);
    const res = sortedDataCopy?.sort(compareFoo);
    res && setSortedData(res);
  }, [leftoversSort.order, leftoversSort.sortBy, topRecipes]);

  return (
    <>
      <div className={styles.content}>
        <TabsBar tabs={tabs} activeItem={activeTab} setActiveTab={setActiveTab} />
        <div className={styles.specs}>
          <SpecItem
            label="общий вес остатков"
            value={
              Number(topRecipes?.remaining_bags.total.total_remind_weight !== 0) ? (
                <>
                  {topRecipes?.remaining_bags.total.total_remind_weight.toLocaleString(
                    'ru-Ru',
                    { maximumFractionDigits: 1 },
                  ) || 0}{' '}
                  <RubleRegular customSymbol='т'/> <img src={arrowIcon} className={styles.arrowIcon} />{' '}
                  {(
                    Number(topRecipes?.remaining_bags.total.total_remind_weight) +
                    Number(topRecipes?.remaining_bags.total.total_remind_weight_diffs)
                  ).toLocaleString('ru-Ru', {
                    maximumFractionDigits: 1,
                  }) || 0}{' '}
                  <RubleRegular customSymbol='т'/>
                </>
              ) : (
                <>
                  {topRecipes?.remaining_bags.total.total_remind_weight?.toLocaleString(
                    'ru-Ru',
                    { maximumFractionDigits: 1 },
                  ) || 0}{' '}
                  <RubleRegular customSymbol='т'/>
                </>
              )
            }
          />
          <SpecItem
            label="общая стоимость остатков"
            value={
              <>
                {(
                  topRecipes?.remaining_bags.total.total_remind_price || 0
                ).toLocaleString('RU-ru', { maximumFractionDigits: 0 })}{' '}
                <RubleRegular customSymbol='₽'/> <DetalisationTooltip infoIcon={true} status="AfterChange" />
              </>
            }
          />
          <SpecItem
            label="общая стоимость логистики остатков"
            value={<>{(
              topRecipes?.remaining_bags.total.total_remind_price_logistic || 0
            ).toLocaleString('RU-ru', { maximumFractionDigits: 0 })} <RubleRegular customSymbol='₽'/></>}
          />
          <SpecItem
            label="стоимость всех остатков с учетом логистики"
            value={<>{(
              topRecipes?.remaining_bags.total.total_remind_price_netto || 0
            ).toLocaleString('RU-ru', { maximumFractionDigits: 0 })} <RubleRegular customSymbol='₽'/></>}
          />
          {/* <div className={styles.profitBadge} style={{ opacity: 0 }}>
            <span className={styles.label}>общая выгода от миксования</span>
            <span className={styles.profit}>
              {(
                topRecipes?.mixes.reduce(
                  (prev, current) => prev + current.mixing_profit,
                  0,
                ) || 0
              ).toLocaleString('RU-ru', { maximumFractionDigits: 0 })}{' '}
              ₽
            </span>
          </div> */}
        </div>
        <Sorter
          sortOption={leftoversSort.sortBy}
          setSortOption={setLeftoversSortValue}
          orderBy={leftoversSort.order as 'asc' | 'desc'}
          setOrderBy={setLeftoversSortOrder}
        />
        <LeftoversList selectRecipeFoo={selectRecipeFoo} leftoversList={sortedData} />
        {/* {activeTab === 0 ? (
          <MixesTab selectRecipeFoo={selectRecipeFoo} />
        ) : (
          <LeftoversTab selectRecipeFoo={() => {}} />
        )} */}
      </div>
    </>
  );
};
